import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import { auth } from "../firebase";
import { fetchPartnerCampaignBrands } from "../services/partner/partner.api";
import { useUserPartnerInformation } from "./useUserPartnerInformation";

export function usePartnerCampaignBrands() {
  const [user] = useAuthState(auth);

  const { userPartnerInformation } = useUserPartnerInformation(user?.uid);

  const partnerId = userPartnerInformation?.data?.partnerId;

  return useQuery(
    ["partnerCampaignBrands", partnerId],
    () => fetchPartnerCampaignBrands(partnerId),
    { enabled: !!partnerId, select: (data) => data.data }
  );
}
